// @flow

import type {Store as ReduxStore} from 'redux';
import type {Action, ApiAction} from './typedef';

type ACTION_TYPE = (action: Action<*, *> | ApiAction<*, *>, apiRoot: string, store?: ReduxStore<*, *>) => Promise<*>;

const UNSUPPORTED_API: string => ACTION_TYPE = method => () => {
    return Promise.reject(() => {
        throw new Error(`API does not support method ${method}`);
    });
};

export const UNSUPPORTED_PRINT_API: ACTION_TYPE = UNSUPPORTED_API('print');
export const UNSUPPORTED_DOWNLOAD_API: ACTION_TYPE = UNSUPPORTED_API('download');
export const UNSUPPORTED_UPLOAD_API: ACTION_TYPE = UNSUPPORTED_API('upload');

export const ApiMethods = {
    CONNECT: 'CONNECT',
    DELETE: 'DELETE',
    GET: 'GET',
    HEAD: 'HEAD',
    OPTIONS: 'OPTIONS',
    POST: 'POST',
    PUT: 'PUT',
    PATCH: 'PATCH'
};

export const CONTENT_TYPE_KEY = 'Content-Type';
export const CONTENT_TYPE_FORM_DATA = 'application/x-www-form-urlencoded;charset=UTF-8';
export const CONTENT_TYPE_JSON = 'application/json;charset=UTF-8';
export const CONTENT_TYPE_OCTET_STREAM = 'application/octet-stream';
export const CONTENT_TYPE_SVG = 'image/svg+xml';
export const CONTENT_TYPE_PNG = 'image/png';
export const CONTENT_TYPE_XLS = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const CONTENT_TYPE_PDF = 'application/pdf';


export const TRANSPORT_REQUEST_BODY = 'TRANSPORT_REQUEST_BODY';
export const TRANSPORT_REQUEST_FILE = 'TRANSPORT_REQUEST_FILE';
export const TRANSPORT_REQUEST_PARAMS = 'TRANSPORT_REQUEST_PARAMS';
export const TRANSPORT_GET_PARAMS = 'TRANSPORT_GET_PARAMS';

export const CALL_API = 'CALL_API';
export const DOWNLOAD_FILE = 'DOWNLOAD_FILE';
export const PRINT_FILE = 'PRINT_FILE';
export const UPLOAD_FILE = 'UPLOAD_FILE';

export const ConcurrentStrategies = {
    FIRST: 'FIRST',
    LAST: 'LAST',
    DEFAULT: 'DEFAULT'
};

export const OBSOLETE_REQUEST_ERROR = {
    reason: 'OBSOLETE_REQUEST_ERROR',
    message: 'This request is obsolete'
};

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./typedef");
